












import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {GET_LOADING} from '@/store/types';
import {PRINT_GET_PARAMS} from '@/store/modules/print/types';

import registration from './market-break-down-registration.page.vue';
import sales from './market-break-down-sales.page.vue';

@Component({
  components: {
    registration,
    sales
  }
})
export default class extends Vue {
  @Getter(GET_LOADING)
  isLoading: any;
  @Getter(PRINT_GET_PARAMS)
  params: any;

  public get dataQuery() {
    return {
      ...this.params.filters,
      name: this.params.reportName
    };
  }

  mounted() {
    $(`<style>@page { size: landscape}; }</style>`).appendTo(
        document.head
    );
  }
}
